import { MpfInputBaseProps, mpfInputDefaults, MpfInputEmits } from '../MpfInput/MpfInputBaseProps';

export interface MpfInputTextareaProps extends MpfInputBaseProps {
  rows?: number;
  maxLength?: number;
  counter?: boolean;
}

export type MpfTextareaEmits = MpfInputEmits;

export const mpfTextareaDefaults = {
  ...mpfInputDefaults,
  rows: 3,
  counter: false,
};
